<template>
  <el-dialog
    class="co-chain-invoke-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="deployTit"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item ref="contractRef" label="选择合约" prop="contractName">
        <el-select
          v-model="dataForm.contractName"
          placeholder="请选择"
          class="auto-width"
          @change="handleSelect"
        >
          <el-option v-for="ele in options" :key="ele.id" :label="ele.name" :value="ele.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调用方法" prop="methodName">
        <el-select
          v-model="dataForm.methodName"
          placeholder="请选择"
          class="auto-width"
          @change="handleMethod"
        >
          <el-option
            v-for="(ele, i) in methodOptions"
            :key="ele.methodKey + i"
            :label="ele.methodName"
            :value="ele.methodName"
          >
          </el-option>
        </el-select>
        <el-input
          v-show="showSelf"
          v-model="selfInput"
          placeholder="请输入自定义方法"
          class="input-self"
        ></el-input>
      </el-form-item>

      <el-form-item v-show="showParam" label="参数" prop="parameters">
        <operate-param ref="param" :disable-pre="disableInput" :list="paramList"></operate-param>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Invoke',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    let validateParam = (rule, value, callback) => {
      if (this.$refs.param.validateParam()) {
        callback()
      } else {
        callback(new Error('请输入参数'))
      }
    }

    return {
      dialogVisible: false,
      disabled: false,
      deployTit: '发起上链',
      position: 'right',
      disableInput: false,
      resize: 'none',
      editRule: {
        contractName: [{ required: true, message: '请输入合约名称', trigger: 'change' }],
        parameters: [{ required: true, validator: validateParam, trigger: 'change' }],
        methodName: [{ required: true, message: '请选择调用方法', trigger: 'change' }]
      },
      dataForm: {
        chainId: '',
        contractName: '',
        parameters: [],
        methodName: ''
      },
      options: [],
      methodOptions: [{ methodName: '自定义', methodKey: 'self' }],
      showSelf: false,
      selfInput: '',

      paramList: [{ key: '', value: '' }],
      showParam: true,
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  methods: {
    getOptions() {
      let param = {
        chainId: this.$route.query.chainId
      }
      this.$apis.chain.getInvokeList(param).then(res => {
        if (res.data) {
          this.options = res.data
        }
      })
    },
    handleCancel() {
      this.disabled = false
      this.$refs.dataForm.clearValidate()
      this.$refs.param.clearParam()
      this.showSelf = false
      this.selfInput = ''
      this.methodOptions = [{ methodName: '自定义', methodKey: 'self' }]
      this.dataForm = {
        chainId: '',
        contractName: '',
        parameters: [],
        methodName: ''
      }
      this.showParam = true
      this.paramList = []
      this.disableInput = false
      this.dialogVisible = false
    },
    handleOpen() {
      this.getOptions()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    handleOk() {
      this.dataForm.parameters = this.$refs.param.getParam()
      this.dataForm.chainId = this.$route.query.chainId
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.disabled = true
          if (this.dataForm.methodName === '自定义') {
            if (!this.$utils.isEmpty(this.selfInput)) {
              this.dataForm.methodName = this.selfInput
            } else {
              this.$message.warning('请填写自定义方法')
              this.disabled = false
              return
            }
          }
          if (this.$utils.isEmpty(this.$refs.param.getParam())) {
            this.$message.warning('请填写参数')
            this.disabled = false
            return
          }
          this.$apis.chain.invokeContract(this.dataForm).then(res => {
            if (res) {
              this.$emit('update:list')
              this.handleCancel()
            }
          })
        } else {
          this.$message.warning('请完善内容')
          this.disabled = false
          return
        }
      })
    },
    handleSelect(val) {
      this.disableInput = true
      let item = this.options.filter(ele => ele.name === val)
      this.$apis.chain.getContractDetail({ id: item[0].id }).then(res => {
        if (res.data) {
          if (!this.$utils.isEmpty(JSON.parse(res.data.Methods))) {
            let arr = JSON.parse(res.data.Methods)
            arr.map(ele => {
              this.methodOptions.push(ele)
            })
          } else {
            let methodLength = this.methodOptions.length
            this.methodOptions.splice(1, methodLength - 1)
            this.paramList = []
            this.$refs.param.clearParam()
            this.dataForm.methodName = ''
            this.disableInput = false
          }
        }
      })
    },
    handleMethod(val) {
      if (val === '自定义') {
        this.$refs.param.clearParam()
        this.showSelf = true
        this.disableInput = false
      } else {
        this.showSelf = false
        this.disableInput = true
        let item = this.methodOptions.filter(ele => ele.methodName === val)
        let keys = item[0]['methodKey']
        if (!this.$utils.isEmpty(keys)) {
          this.showParam = true
          let keyList = keys.split(',')
          this.paramList = keyList.map(elem => {
            let obj = {
              key: elem,
              value: ''
            }
            return obj
          })
          this.$refs.param.updateParam(this.paramList)
        } else {
          this.paramList = []
          this.showParam = false
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('co-chain-invoke-dialog', (), ());
.co-chain-invoke-dialog.common-dialog {
  @include adaptation(());
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
